export const catalogTreeListSelector = store => store.catalogTree.list;
export const isLoadingCatalogTreeSelector = store => store.catalogTree.isLoading;
export const errorCatalogTreeList = store => store.catalogTree.error;
